import { render, staticRenderFns } from "./CieloDropdownItem.vue?vue&type=template&id=522d89e6&scoped=true"
import script from "./CieloDropdownItem.vue?vue&type=script&lang=js"
export * from "./CieloDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./CieloDropdownItem.vue?vue&type=style&index=0&id=522d89e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522d89e6",
  null
  
)

export default component.exports